export const options = {
  nik: /^[0-9]{16}$/,
  email: /^([\w.])*?([a-z0-9])+@([\w-]+\.)+[\w-]{2,}$/,
};

export const nik = (value: string) => {
  return options.nik.test(value);
};

export const email = (value: string) => {
  return options.email.test(value);
};
